import { render, staticRenderFns } from "./SamplePage.vue?vue&type=template&id=2c20eb7e&scoped=true&"
import script from "./SamplePage.vue?vue&type=script&lang=js&"
export * from "./SamplePage.vue?vue&type=script&lang=js&"
import style0 from "./SamplePage.vue?vue&type=style&index=0&id=2c20eb7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20eb7e",
  null
  
)

export default component.exports